<template>
    <div class="home-page">
		<Header></Header>
		<div class="content">
      <div class="drop-down-content">
        <div class="login-content">
          <div class="h1 ac fs50 fw7 mt100">{{$t('ChangePassword')}}</div>
          <div class="input-div">
            <div class="span fw7">{{$t('OldPassword')}}</div>
            <div class="input-item">
              <input class="input" :class="!eyes0?'disc':'none'" ref="getFocus1" v-model="oldpassword" :placeholder="$t('OldPassword')">
              <span>
                <img  @click="fnclear(0)" v-if="!eyes0" src="../../static/images/cls-eye.png">
                <img  @click="fnclear(0)" v-else src="../../static/images/eyes.png">
              </span>
            </div>
          </div>
          <div class="input-div">
            <div class="span fw7">{{$t('newPassword')}}</div>
            <div class="input-item">
              <input class="input" v-model="newpassword" :class="!eyes1?'disc':'none'" ref="getFocus2" :placeholder="$t('newPassword')">
              <span>
                <img  @click="fnclear(1)" v-if="!eyes1" src="../../static/images/cls-eye.png">
                <img  @click="fnclear(1)" v-else src="../../static/images/eyes.png">
              </span>
            </div>
          </div>
          <div class="ac mt100">
            <button class="btn btn-blue" style="width:40%;" @click="goLogin">{{$t('Submit')}}</button>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        oldpassword:'',
        newpassword:'',
        eyes0:false,
        eyes1:false,

      }
    },
	created(){
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
    fnclear(type){
    	let that = this;
    	if(type==0){
    		if(that.eyes0){
    			that.eyes0=false;
    		}else{
    			that.eyes0=true;
    		}
    	}else if(type==1){
    		if(that.eyes1){
    			that.eyes1=false;
    		}else{
    			that.eyes1=true;
    		}
    	}
    },
		goLogin(){
		  let that = this
		  if(that.oldpassword==''){
		  	that.$utils.alertText(that.$t('tips'),60)
		  	return;
		  }
		  let data ={
		      'oldpassword':this.oldpassword,
		      'newpassword':this.newpassword,
		  }
		  that.$api.post('/api/user/changepwd',data,r =>{
		  	//that.$parent.returnCode(r,function(){
		    that.$utils.alertText(r.msg,80);
        this.$router.push({path:'/myAccount',query:{}});
		      console.log(r.data.userinfo.token)
		  	//})
		  })
		},
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;}
  .input{background:#fff;height:47px;border:none;border-radius: 20px;font-size: 27px;font-family:ChevinProBold;padding:0 20px;width:80%;}
  .input-div{margin:30px 40px 20px;}
  .input-div .span{margin: 0 auto 20px;width:80%;}
  .input-item{background:#fff;border-radius: 20px;height: 60px;line-height: 60px;width:80%;margin: 0 auto;}
  .input-div div span{font-size:inherit;padding-left: 30px;}
  .disc{-webkit-text-security: disc;}
  .none{-webkit-text-security: none;}
</style>



// WEBPACK FOOTER //
// src/page/changePassword.vue